module.exports = __webpack_public_path__ + "static/img/icon2_on.88e158ef.png";